import { render, staticRenderFns } from "./_course_promo_video_upload.vue?vue&type=template&id=b43af130"
import script from "./_course_promo_video_upload.vue?vue&type=script&lang=js"
export * from "./_course_promo_video_upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports